export default "__VITE_ASSET__CJXjmkKo__"